import LinkWithPage from './LinkWithPage';

export default LinkWithPage;
